"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var _absoluteUrlRuntime = require("@insided/shared/utils/absoluteUrlRuntime");

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _Answer = _interopRequireDefault(require("@insided/destination/icons/Answer"));

var _Warning = _interopRequireDefault(require("@insided/destination/icons/Warning"));

var _Upload = _interopRequireDefault(require("@insided/destination/icons/Upload"));

var _File = _interopRequireDefault(require("@insided/destination/icons/File"));

var _Download = _interopRequireDefault(require("@insided/destination/icons/Download"));

var _buttonControl = _interopRequireDefault(require("../button-control"));

var _ImportBox = _interopRequireDefault(require("./ImportBox"));

var _Message = require("@insided/deprecated-control/ui-components/Message");

var _ImportErrors = _interopRequireDefault(require("./ImportErrors"));

var _Button = _interopRequireDefault(require("@insided/shared/uikit/Button"));

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var ImportView = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(ImportView, _Component);

  var _super = _createSuper(ImportView);

  function ImportView(props) {
    var _this;

    (0, _classCallCheck2.default)(this, ImportView);
    _this = _super.call(this, props);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "downloadLink", void 0);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "state", {
      fileName: undefined,
      file: null
    });
    _this.downloadLink = "/".concat(props.type, "/download");
    return _this;
  } // eslint-disable-next-line class-methods-use-this


  (0, _createClass2.default)(ImportView, [{
    key: "openFileSelector",
    value: function openFileSelector() {
      var fileUploader = document.querySelector('#file-selector');

      if (fileUploader) {
        fileUploader.click();
      }
    }
  }, {
    key: "setFileName",
    value: function setFileName(event) {
      var target = event.target;
      var uploadedFile = target.files[0];
      var uploadedFileName = uploadedFile.name;
      this.setState({
        fileName: uploadedFileName,
        file: uploadedFile
      });
    }
  }, {
    key: "removeSelectedFile",
    value: function removeSelectedFile(e) {
      if (this.props.isLoading) {
        return;
      }

      var target = e.target;
      target.value = '';
      this.setState({
        fileName: undefined,
        file: null
      });
    }
  }, {
    key: "showImportView",
    value: function showImportView() {
      this.setState({
        fileName: undefined,
        file: null
      });
      this.props.onTryAgain();
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          infoText = _this$props.infoText,
          uploadFile = _this$props.uploadFile,
          showImportSuccess = _this$props.showImportSuccess,
          showImportError = _this$props.showImportError,
          calloutText = _this$props.calloutText,
          isLoading = _this$props.isLoading,
          type = _this$props.type,
          uploadedCount = _this$props.uploadedCount,
          errors = _this$props.errors,
          successAction = _this$props.successAction;
      var _this$state = this.state,
          fileName = _this$state.fileName,
          file = _this$state.file;
      return (0, _preact.h)("div", {
        className: "import-container"
      }, showImportSuccess && (0, _preact.h)("div", null, (0, _preact.h)(_ImportBox.default, {
        icon: (0, _preact.h)(_Answer.default, {
          className: "icon-import-success",
          width: 80,
          height: 80
        }),
        title: "Import complete!"
      }, (0, _preact.h)("div", {
        className: "import-statistics"
      }, (0, _preact.h)("div", {
        className: "import-statistics-count"
      }, (0, _preact.h)("div", {
        className: "upload-number"
      }, uploadedCount), (0, _preact.h)("div", {
        className: "upload-description"
      }, type.charAt(0).toUpperCase() + type.slice(1), " imported")), (errors === null || errors === void 0 ? void 0 : errors.length) !== undefined ? (0, _preact.h)("div", {
        className: "import-statistics-count"
      }, (0, _preact.h)("div", {
        className: "upload-number"
      }, errors.length), (0, _preact.h)("div", {
        className: "upload-description"
      }, "Errors")) : null), (0, _preact.h)(_buttonControl.default, {
        variant: "secondary",
        newStyle: true,
        size: "medium",
        title: "Go back to ".concat(type, " overview"),
        onClick: function onClick() {
          return window.location.assign("/".concat(type, "/overview"));
        }
      }), successAction || null), errors && errors.length > 0 ? (0, _preact.h)(_ImportErrors.default, {
        errors: errors
      }) : null), showImportError && (0, _preact.h)(_ImportBox.default, {
        icon: (0, _preact.h)(_Warning.default, {
          className: "icon-import-error",
          width: 80,
          height: 80
        }),
        title: "Import failed :("
      }, (0, _preact.h)("div", {
        className: "upload-description"
      }, "Please download the", ' ', (0, _preact.h)("a", {
        href: (0, _absoluteUrlRuntime.resolveUrl)(this.downloadLink),
        className: "download-link",
        target: "_blank",
        rel: "noreferrer"
      }, "template CSV file"), ' ', "and check that your file matches the format of the template."), (0, _preact.h)(_buttonControl.default, {
        variant: "brand",
        newStyle: true,
        size: "medium",
        title: "Try again",
        onClick: function onClick() {
          return _this2.showImportView();
        }
      })), !showImportSuccess && !showImportError && (0, _preact.h)("div", {
        className: "import-data-container"
      }, calloutText && (0, _preact.h)(_Message.Message, {
        text: calloutText
      }), (0, _preact.h)("div", {
        className: "upload-container"
      }, (0, _preact.h)(_Upload.default, {
        className: "icon-upload"
      }), (0, _preact.h)("div", {
        className: "upload-title-text"
      }, "Upload your CSV file"), (0, _preact.h)("div", {
        className: "upload-info-text"
      }, infoText), (0, _preact.h)("div", {
        className: "upload-link"
      }, (0, _preact.h)("div", null, fileName === undefined ? (0, _preact.h)("div", null, (0, _preact.h)(_buttonControl.default, {
        variant: "brand",
        newStyle: true,
        size: "medium",
        class: "qa-file-selector",
        title: " Select file from your computer",
        onClick: function onClick() {
          return _this2.openFileSelector();
        }
      }), (0, _preact.h)("input", {
        type: "file",
        id: "file-selector",
        style: "display:none;",
        onChange: function onChange(e) {
          return _this2.setFileName(e);
        },
        accept: ".csv"
      })) : (0, _preact.h)("div", {
        className: "upload-file-wrapper"
      }, (0, _preact.h)("span", {
        className: "icon-file-name"
      }, (0, _preact.h)(_File.default, {
        className: "icon-file"
      })), (0, _preact.h)("span", {
        className: "upload-file-name"
      }, fileName), (0, _preact.h)("span", null, ' ', "(", (0, _preact.h)(_Button.default, {
        onClick: function onClick(e) {
          return _this2.removeSelectedFile(e);
        },
        className: "remove-file ".concat(isLoading ? 'remove-file-disabled' : ''),
        variant: "text"
      }, "Remove"), ")")), fileName && (0, _preact.h)(_buttonControl.default, {
        variant: "brand",
        newStyle: true,
        size: "medium",
        class: "upload-file",
        title: "Upload file",
        onClick: function onClick() {
          return uploadFile(file);
        },
        isLoading: isLoading
      }))), !fileName && (0, _preact.h)("div", null, (0, _preact.h)("div", {
        className: "download-wrapper"
      }, (0, _preact.h)("a", {
        href: (0, _absoluteUrlRuntime.resolveUrl)(this.downloadLink),
        target: "_blank"
      }, (0, _preact.h)("span", {
        className: "icon-download-link"
      }, (0, _preact.h)(_Download.default, {
        className: "icon-download"
      })), (0, _preact.h)("span", {
        className: "download-link"
      }, "Download template CSV file")))))));
    }
  }]);
  return ImportView;
}(_preact.Component);

var _default = ImportView;
exports.default = _default;